import { Button, Grid, IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";

//import SvgIcon from '../../components/assets/svgIcon'

/*
 * ImageButton Component
 * @param {string} title - The title of the button.
 * @param {string} detail - Optional detail text to display below the title.
 * @param {string} route - Optional route to navigate to when the button is clicked.
 * @param {function} onClick - Optional function to call when the button is clicked.
 * @param {string} customclassname - Optional CSS class name for styling the button.
 */
export default function CatalogButton({ itemInfo, onClick = null, allowEdit = false, setEditInfo, setModalVisible, uri }) {
    const navigate = useNavigate();

    const handleSelectAction = () => {
        if (uri != null) {
            navigate(`/${uri}/${itemInfo.code}`);
        }
        if (onClick != null) {
            onClick();
        }
    };

    const handleEdit = () => {
        setEditInfo(itemInfo)
        setModalVisible()
    }

    return (
        <div style={{ position: "relative" }}>
            {allowEdit && <IconButton
                size="small"
                onClick={handleEdit}
                className="btn-floating"
            >
                <EditIcon fontSize="small" className="text-btn-floating" />
            </IconButton>}
            <Button className={"catalog-button py-4"} variant="outlined" onClick={handleSelectAction} >
                <Grid>
                    {itemInfo.reference &&
                        <img
                            src={itemInfo.reference.path}
                            className="img-fluid catalog-img"
                            alt="Catalog Icon" />
                    }
                </Grid>
                <Grid>
                    <h5 className="mt-2">{itemInfo.name}</h5>
                </Grid>
            </Button>
        </div>
    );
}
